import React, { Fragment } from "react";
import axios from "axios";
import { openIdb } from "./storageManager";
import { nodeUrl } from "../../../constants/config";

export const months = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};
export const monthsShort = {
  "01": "Jan",
  "02": "Feb",
  "03": "Mar",
  "04": "Apr",
  "05": "May",
  "06": "Jun",
  "07": "Jul",
  "08": "Aug",
  "09": "Sept",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};
export const dayNames = ["S", "M", "T", "W", "T", "F", "S"];

export const getDays = (year, month, day, mode) => {
  const givenDate = new Date(year, month - 1, day);

  let days = {},
    dates = [];

  if (typeof mode !== "undefined" && mode === "month") {
    var firstDay = new Date(givenDate.getFullYear(), givenDate.getMonth(), 1);
    var lastDay = new Date(
      givenDate.getFullYear(),
      givenDate.getMonth() + 1,
      0
    );
    var loopCount = lastDay.getDate() - 1;
  } else {
    var currentWeekDay = givenDate.getDay();
    var lessDays = currentWeekDay === 0 ? 6 : currentWeekDay - 1;
    var firstDay = new Date(
      new Date(givenDate).setDate(givenDate.getDate() - lessDays)
    );
    var loopCount = 6;
  }
  days[1] = {
    day: ("0" + firstDay.getDate()).slice(-2),
    dayName: dayNames[firstDay.getDay()],
    month: ("0" + (firstDay.getMonth() + 1)).slice(-2),
    year: firstDay.getFullYear(),
    date: firstDay.toLocaleDateString(),
  };
  dates.push(days[1].year + "-" + days[1].month + "-" + days[1].day);
  for (let i = 1; i <= loopCount; i++) {
    let nextDay = new Date(firstDay);
    nextDay.setDate(nextDay.getDate() + i);
    days[i + 1] = {
      day: ("0" + nextDay.getDate()).slice(-2),
      dayName: dayNames[nextDay.getDay()],
      month: ("0" + (nextDay.getMonth() + 1)).slice(-2),
      year: nextDay.getFullYear(),
      date: nextDay.toLocaleDateString(),
    };
    dates.push(
      days[i + 1].year + "-" + days[i + 1].month + "-" + days[i + 1].day
    );
  }
  return {
    days: days,
    weekStart: days[1],
    weekEnd: days[loopCount],
    dates: dates,
  };
};

export const getNextSet = (year, month, day, calendarMode) => {
  const givenDate = new Date(year, month - 1, day);
  if (calendarMode === "week") {
    var currentWeekDay = givenDate.getDay();
    var lessDays = currentWeekDay === 0 ? 6 : currentWeekDay - 1;
    var firstDay = new Date(
      new Date(givenDate).setDate(givenDate.getDate() - lessDays)
    );
    var nextMonday = new Date(
      new Date(firstDay).setDate(firstDay.getDate() + 7)
    );
    return nextMonday;
  } else {
    var firstDayOfNextMonth = new Date(
      givenDate.getFullYear(),
      givenDate.getMonth() + 1,
      1
    );
    return firstDayOfNextMonth;
  }
};

export const getPreviousSet = (year, month, day, calendarMode) => {
  const givenDate = new Date(year, month - 1, day);
  if (calendarMode === "week") {
    var currentWeekDay = givenDate.getDay();
    var lessDays = currentWeekDay === 0 ? 6 : currentWeekDay - 1;
    var firstDay = new Date(
      new Date(givenDate).setDate(givenDate.getDate() - lessDays)
    );
    var previousMonday = new Date(
      new Date(firstDay).setDate(firstDay.getDate() - 7)
    );
    return previousMonday;
  } else {
    var firstDayOfPreviousMonth = new Date(
      givenDate.getFullYear(),
      givenDate.getMonth() - 1,
      1
    );
    return firstDayOfPreviousMonth;
  }
};

export const unsetArrayItem = (itemValue, items) => {
  const array = items;
  const index = items.indexOf(itemValue);
  if (index > -1) {
    array.splice(index, 1);
  }
  return array;
};

export const chunk = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size)
  );

export const RenderDots = () => {
  return (
      <div className="event-dots-wrapper">
        <span className="event-dot"></span>
      </div>
    );
};

export const getWeeklyEvents = (params) => {
  //  console.log('param', params);
  const accessToken = params.accessToken;
  const uuid        = params.uuid;
  const accountId   = params.accountId;
  const limit       = 1000;
  // const uuid        = '63620ea160e50';

  const selectedDate = params?.selectedDate;
  const calendarMode = params?.calendarMode;

  let dbEvent         = {};
  let events          = {};
  if(accessToken){
    const headers = {
      'Content-Type': 'application/json',
      // 'x-access-token' : 'NKNvNTNtNp7wNzNX7uNzNT7v7ZNjN'
      'Authorization': `Bearer ${accessToken}`
    }

    let limit     = 10;
    let startDate = '';
    let endDate   = '';
    if(calendarMode == 'week'){
      startDate = selectedDate;
      endDate   = selectedDate;
    } else {
      if(params.days.length > 0){
        startDate   = params.days[0];
        endDate     = params.days[params.days.length-1];
      }
    }
    axios.get(nodeUrl+'/events/calendar?limit='+limit+'&page=1&account_id='+accountId+'&us_uuid='+uuid+'&start_date='+startDate+'&end_date='+endDate, {
      headers
    })
    .then((response) => {
      // if(response?.data?.result?.length > 0){
        dbEvent = response.data.result;
        // setReminder(response.data.result.events)
      // }

      if (typeof params.days !== "undefined") {
        for (let i = 0; i < params.days.length; i++) {
          if (typeof dbEvent[params.days[i]] !== "undefined") {
            events[params.days[i]] = dbEvent[params.days[i]];
          }
        }
      }

      return events;
    })
    .catch((error) => {
      // Error
      if (error.response) {
        console.log('err1', error.response);
      } else if (error.request) {
          console.log('err2',error.request);
      } else {
          console.log('Error', error.message);
      }
      console.log(error.config);
      return events;
    });
  }else {
    return events;
  }
  /* dbEvent = {
    "2022-11-03": [
      {
        itemType: "live",
        itemName: "Interface Design Assignement",
        itemLink: "https://www.youtube.com/watch?v=U3_uTgwpXw8",
        startTime: "10:30 AM",
        endTime: "11:30 AM",
      },
      {
        itemType: "assignment",
        itemName: "Preparatory Batch for Judiciary Exams Explanation",
        itemLink: "https://mykademyapisupport.mykademy.com/login",
        startTime: "10:30 AM",
        endTime: "11:30 AM",
      },
      {
        itemType: "assignment",
        itemName: "Judiciary Exams Explanation",
        itemLink: "https://mykademyapisupport.mykademy.com/login",
        startTime: "10:30 AM",
        endTime: "11:30 AM",
      },
    ],
    "2022-12-01": [
      {
        itemType: "live",
        itemName: "Introduction",
        itemLink: "https://www.youtube.com/watch?v=U3_uTgwpXw8",
        startTime: "10:30 AM",
        endTime: "11:30 AM",
      },
      {
        itemType: "assignment",
        itemName: "Judiciary Exams Explanation",
        itemLink: "https://mykademyapisupport.mykademy.com/login",
        startTime: "10:30 AM",
        endTime: "11:30 AM",
      },
      {
        itemType: "assignment",
        itemName: "Judiciary Explanation",
        itemLink: "https://mykademyapisupport.mykademy.com/login",
        startTime: "10:30 AM",
        endTime: "11:30 AM",
      },
    ],
    "2022-11-07": [
      {
        itemType: "live",
        itemName: "Introduction",
        itemLink: "https://www.youtube.com/watch?v=U3_uTgwpXw8",
        startTime: "10:30 AM",
        endTime: "11:30 AM",
      },
    ],
  }; */

};
